// extracted by mini-css-extract-plugin
export default {"more":"Q033F","icon":"SQ6jF","container":"SrVO9"};